import { heroStats } from '../data/content';
import kataVideo from '../assets/kata-hero.mp4';
import kataPoster from '../assets/kata-hero-poster.jpg';
import Logo from './Logo';
import './Hero.css';

export default function Hero() {
  return (
    <section id="inicio" className="hero pin-dark">
      <div className="hero__background">
        <video
          className="hero__bg-video"
          src={kataVideo}
          poster={kataPoster}
          preload="auto"
          autoPlay
          muted
          loop
          playsInline
        />
        <div className="hero__overlay" />
      </div>

      <div className="hero__content">
        <Logo size={72} className="hero__crest hero__anim hero__anim--1" />

        <div className="hero__eyebrow hero__anim hero__anim--1">
          Karate Do Shito Ryu · Gimnasio
        </div>

        <h1 className="hero__title hero__anim hero__anim--2">
          <span className="hero__title-kicker">Centro de Entrenamiento</span>
          KAMAE
        </h1>

        <p className="hero__tagline serif hero__anim hero__anim--3">
          Bienvenido a casa
        </p>
        <div className="hero__tagline-jp hero__anim hero__anim--3" lang="ja">
          お帰りなさい · <span className="hero__tagline-romaji">okaerinasai</span>
        </div>

        <div className="hero__actions hero__anim hero__anim--3">
          <a href="#contacto" className="btn btn--ferrari">
            Descubrir el dojo <span className="btn__arrow">›</span>
          </a>
        </div>
      </div>

      <div className="hero__spec hero__anim hero__anim--4">
        {heroStats.map((stat) => (
          <div key={stat.label} className="hero__spec-item">
            <span className="hero__spec-value">
              {stat.value}
              {stat.valueSuffix && (
                <span className="hero__spec-suffix">{stat.valueSuffix}</span>
              )}
            </span>
            <span className="hero__spec-label">{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}